import { Deserializable } from '../../protocols/deserializable';
import { HighGuideProductSignal } from '../../product/dto/product-signal/high-guide-product-signal';
import { ProductSignalUser } from '../../product/dto/product-signal/product-signal-user';

/**
 * The Recently Recommended branch of the insights payload: recent signals plus every author they reference.
 *
 * Both halves are the existing signal models rather than insight-specific copies - the endpoint returns the same
 * two shapes the websocket and REST signal reads already return, so they are reused verbatim. Authors arrive in a
 * flat list and are joined back on `highGuideUserId`; see `getUsersById`.
 */
export class HighGuideRecentRecommendations implements Deserializable {
  public users: ProductSignalUser[];
  public recommendations: HighGuideProductSignal[];

  onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;
    this.users = Deserialize?.arrayOf(ProductSignalUser, this.users) || [];
    this.recommendations = Deserialize?.arrayOf(HighGuideProductSignal, this.recommendations) || [];
  }

  /**
   * Authors keyed by id for the card join.
   *
   * Anonymous teammates all share the `anonymous` sentinel id, so they collapse onto one entry here. That is
   * correct for rendering - every anonymous card draws the same placeholder author - but it means the map size is
   * not a contributor count.
   */
  getUsersById(): Map<string, ProductSignalUser> {
    return new Map((this.users || []).map(user => [user?.userId, user]));
  }
}
